var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"set-page"}},[_c('lang',{staticClass:"lang-box"}),_c('div',{staticClass:"set-password"},[(_vm.setState)?_c('set-password-header'):_vm._e(),(_vm.setState)?_c('div',{staticClass:"form-box"},[_c(_vm.currentView[_vm.state],{tag:"component",attrs:{"email":_vm.email},on:{"next":_vm.handleNext}})],1):_c('set-password-finish')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }